/*
 * Copyright (c) Funtip GbR 2018.
 * Simon Oldeboershuis, Perry Prust
 */

import { Action, isType } from 'typescript-fsa';
import { Album } from '../../../services/playlist';
import { setAlbumList, setAlbumSearch, setAlbumSearchCount, setAlbumSearchCurrentPos } from './actions';

export interface AlbumListState {
    albumList: Album[];
    albumSearch: string;
    albumSearchCurrentPos: number;
    albumSearchCount: number;
    albumSearchPageSize: number;
}

const initialAlbumListState: AlbumListState = {
    albumList: [],
    albumSearch: '',
    albumSearchCurrentPos: 0,
    albumSearchCount: 0,
    albumSearchPageSize: 20
};

export function albumListReducer(state: AlbumListState = initialAlbumListState, action: Action<{}>) {

    if (isType(action, setAlbumList)) {
        return Object.assign({}, state, {albumList: action.payload});

    } else if (isType(action, setAlbumSearch)) {
        return Object.assign({}, state, {albumSearch: action.payload});

    } else if (isType(action, setAlbumSearchCount)) {
        return Object.assign({}, state, {albumSearchCount: action.payload});

    } else if (isType(action, setAlbumSearchCurrentPos)) {
        return Object.assign({}, state, {albumSearchCurrentPos: action.payload});

    } else {
        return state;
    }

}
